import {
  LayoutGridIcon,
  LinkIcon,
  MegaphoneIcon,
  SparklesIcon,
  TagIcon,
  TargetIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react';

export interface FileTypeCellModel {
  /** null when `tags` is empty or absent: the cell renders the muted dash. */
  primary: { label: string; Icon: LucideIcon } | null;
  /** 0 when nothing overflows. */
  overflowCount: number;
  /** Hidden tag labels, for the `+N` tooltip. */
  overflowLabels: string[];
}

/**
 * Known tag -> icon mapping. Deliberately not an exhaustive `Record`: tags
 * are assigned server-side and a new one must fall back rather than blank
 * the cell (see `buildFileTypeCell`).
 */
export const TAG_ICONS: Record<string, LucideIcon> = {
  'Brand Core': SparklesIcon,
  Audience: UsersIcon,
  'Content Pillars': LayoutGridIcon,
  'Engagement Tactics': TargetIcon,
  Influencers: MegaphoneIcon,
  Sources: LinkIcon,
};

export function buildFileTypeCell(tags: string[] | undefined): FileTypeCellModel {
  if (!tags || tags.length === 0) {
    return { primary: null, overflowCount: 0, overflowLabels: [] };
  }

  const [firstTag, ...rest] = tags;

  return {
    primary: { label: firstTag, Icon: TAG_ICONS[firstTag] ?? TagIcon },
    overflowCount: rest.length,
    overflowLabels: rest,
  };
}
